import Box from "@mui/material/Box";

const TabPanel = (props) => {
	const { children, value, index, TabPanelBoxProps, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box
					{...TabPanelBoxProps}
					sx={[
						{
							py: 3,
						},
						...(Array.isArray(TabPanelBoxProps.sx)
							? TabPanelBoxProps.sx
							: [TabPanelBoxProps.sx]),
					]}
				>
					{children}
				</Box>
			)}
		</div>
	);
};

export default TabPanel;
